export default class DriverQualification {
  constructor(liked = false, options = [], comment = '') {
    this.liked = liked;
    this.options = options;
    this.comment = comment;
  }
}
